<template>
  <div>
    <a-spin :spinning="spinning">
      <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
      </base-header>

      <div class="container-fluid mt--7 spin-content">
        <div class="row">
          <div class="col-auto">
            <router-link :to="{ name: 'pos_documents' }">
              <h6 class="heading-small ml-8" style="color: white">
                ⟵ Back to Pos Documents
              </h6>
            </router-link>
          </div>
        </div>

        <div class="row mt-2 mx-7">
          <div class="col">
            <div class="card shadow">
              <div class="card-header px-4 py-3 bg-transparent">
                <div v-if="posDocument.status == 'P'" class="row px-3">
                  <!-- <h6 class="heading-small p-0 m-0">
                    TRANS ID # {{ posDocument.trans_id }}
                  <br/>
                    OR/SI NO # {{ posDocument.invoice_no }}
                  </h6> -->
                  <div
                    v-if="posDocument.is_voided == true"
                    class="col d-flex justify-content-end"
                  >
                    <h6 class="heading-small p-0 m-0 mr-2">VOIDED</h6>
                    <i class="fas fa-check-circle text-red"></i>
                  </div>
                  <div v-else class="col d-flex justify-content-end">
                    <h6 class="heading-small p-0 m-0 mr-2">POSTED</h6>
                    <i class="fas fa-check-circle text-green"></i>
                  </div>
                </div>

                <div v-else class="row px-3">
                  <!-- <h6 class="heading-small p-0 m-0">
                    TRANS ID # {{ posDocument.trans_id }}
                  </h6> -->
                  <div
                    v-if="posDocument.status == 'V'"
                    class="col d-flex justify-content-end"
                  >
                    <h6 class="heading-small p-0 m-0 mr-2">VOIDED</h6>
                    <i class="fas fa-minus-circle text-red"></i>
                  </div>
                  <div
                    v-else-if="posDocument.status == 'R'"
                    class="col d-flex justify-content-end"
                  >
                    <h6 class="heading-small p-0 m-0 mr-2">RETURN</h6>
                    <i class="fas fa-minus-circle text-red"></i>
                  </div>
                </div>
              </div>
              <div class="card-body mx-4">
                <div class="row">
                  <h3 class="font-weight-bold">Header Details</h3>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Site</h6>
                    {{ posDocument.site_name }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Terminal</h6>
                    {{ posDocument.terminal_name }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Trans ID</h6>
                    {{ posDocument.trans_id }}
                  </div>
  
                  <div class="col" v-if="posDocument.document_type_code == 'POS' && posDocument.document_trans_code == 'ORO'">
                    <h6 class="heading-small text-muted">Reservation No</h6>
                    {{ posDocument.so_doc }}
                  </div>
                  <div class="col" v-else>
                    <h6 class="heading-small text-muted">OR/SI no</h6>
                    {{ posDocument.invoice_no }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Business Date</h6>
                    {{ posDocument.business_date_formatted }}
                  </div>
                  <div v-if="posDocument.status == 'V'" class="col">
                    <h6 class="heading-small text-muted">Origin Document ID</h6>
                    {{ posDocument.origin_id }}
                  </div>
                </div>
                <hr class="my-3" />
                <div class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Total Quantity</h6>
                    <a-input
                      v-model="posDocument.total_quantity"
                      style="width: 100%"
                      :disabled="true"
                    />
                  </div>
                  <div class="col"></div>
                  <div class="col"></div>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Net Amount</h6>
                    <a-input
                      v-model="total_amount_net_vat"
                      style="width: 100%"
                      :disabled="true"
                    />
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">VAT Amount</h6>
                    <a-input
                      v-model="posDocument.amount_tax"
                      style="width: 100%"
                      :disabled="true"
                    />
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Total with VAT</h6>
                    <a-input
                      v-model="posDocument.amount_due"
                      style="width: 100%"
                      :disabled="true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h3 class="font-weight-bold mt-4 ml-8">POS Document Details</h3>
        <div class="row mt-2 mx-7">
          <div class="col">
            <div class="card shadow">
              <div class="card-body" style="background: #ffffff">
                <div class="table-responsive pt-2">
                  <a-table
                    size="small"
                    :columns="detailsColumn"
                    :dataSource="posDocument.details_pos_document_lines"
                    :pagination="{ pageSize: 10 }"
                  >
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h3 class="font-weight-bold mt-4 ml-8">Payments</h3>
        <div class="row mt-2 mx-7">
          <div class="col">
            <div class="card shadow">
              <div class="card-body">
                <a-table
                  size="small"
                  :columns="paymentsColumn"
                  :dataSource="posDocument.details_pos_document_payments"
                  :pagination="{ pageSize: 5 }"
                >
                </a-table>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mt-4">
          <!-- @click='showAdvancedInfoDiv' -->
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="showAdvancedInfoDiv"
          >
            Other Details {{ showAdvancedInfo ? "↟" : "↡" }}
          </button>
        </div>

        <h3 v-if="showAdvancedInfo" class="font-weight-bold ml-8">
          Other Details
        </h3>
        <div v-if="showAdvancedInfo" class="row mt-2 advanced-info mx-7">
          <div class="col">
            <div class="card shadow">
              <div class="card-body">
                <div class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Cashier</h6>
                    {{ posDocument.cashier_name }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Bagger</h6>
                    {{ posDocument.bagger_name }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Salesman</h6>
                    {{ posDocument.salesman_name }}
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Customer</h6>
                    {{ posDocument.customer_name }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Created At</h6>
                    {{ posDocument.created_at }}
                  </div>
                </div>
                <div v-if="posDocument.status == 'V'" class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Void Date</h6>
                    {{ posDocument.void_date }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Voided By</h6>
                    {{ posDocument.void_by }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />
      </div>
    </a-spin>
  </div>
</template>

<script>
// check details_pos_document_lines.rb model in backend
const posDocumentLines = [
  { title: "Description", dataIndex: "description" },
  { title: "Barcode", dataIndex: "barcode" },
  { title: "Stock No.", dataIndex: "stock_no" },
  { title: "Quantity", dataIndex: "quantity", align: "right" },
  { title: "Price", dataIndex: "mod_price", align: "right" },
  { title: "Net Price", dataIndex: "price", align: "right" },
  { title: "Discount", dataIndex: "discount", align: "right" },
  { title: "Subtotal", dataIndex: "subtotal", align: "right" },
];

const posDocumentCostColumn = { title: "Cost", dataIndex: "cost", align: "right" };

const posDocumentPayments = [
        {title: 'Payment Type', dataIndex: 'type'},
        {title: 'Reference Code', dataIndex: 'reference_code'},
        {title: 'First Name', dataIndex: 'first_name'},
        {title: 'Last Name', dataIndex: 'last_name'},
        {title: 'Amount Tender', dataIndex: 'amount_tender', align: "right"},
        {title: 'Amount Paid', dataIndex: 'amount', align: "right"},
        {title: 'Remarks', dataIndex: 'remark'},
        {title: 'Status', dataIndex: 'status'},
        {title: 'Excess', dataIndex: 'excess'}
    ];

import { mapState } from "vuex";
import HTTPRequest from "../../controllers/httpRequest.js";
import secureStorage from '../../controllers/secureStorage';
// import moment from 'moment';

export default {
  data: function () {
    return {
      spinning: false,
      posDocument: null,
      posDocumentId: null,
      pagination: false,
      detailsColumn: posDocumentLines,
      paymentsColumn: posDocumentPayments,
      showAdvancedInfo: false,
      total_amount_net_vat: 0,
      total_amount_gross_vat: 0,
      accessCostPriceRights: [],
    };
  },
  computed: {
    ...mapState(["endPoint", "serverType"]),
  },
  mounted: async function () {
    this.spinning = true;
    this.posDocumentId = this.$attrs.posDocumentId;
    this.posDocument = await HTTPRequest.getRequest(
      this.endPoint + "pos_documents/" + this.posDocumentId,
      null,
      null
    );

    this.total_amount_net_vat =
      Number(this.posDocument.amount_net_vat) +
      Number(this.posDocument.amount_net_non_vat) +
      Number(this.posDocument.amount_net_zero_rated);
    // this.posDocument.created_at = moment(this.posDocument.created_at).format('MM/DD/YYYY hh:mm')
    
    var accessCostPriceRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
    if (_.isEmpty(accessCostPriceRightsRequest.access_rights) == false) {
      this.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123];
    } else {
      this.accessCostPriceRights = [];
    }

    if (this.accessCostPriceRights.includes("Z")) {
      this.detailsColumn = [
        ...posDocumentLines.slice(0, 4),
        posDocumentCostColumn,
        ...posDocumentLines.slice(4),
      ];
    }
    this.spinning = false;
  },
  methods: {
    showAdvancedInfoDiv() {
      this.showAdvancedInfo = !this.showAdvancedInfo;
    },
  },
};
</script>

<style>
</style>
